/* Copyright © 2026 Xerox Corporation. All Rights Reserved. Copyright protection claimed includes all forms and matters of copyrightable material and information now allowed by statutory or judicial law or hereinafter granted, including without limitation, material generated from the software programs which are displayed on the screen such as icons, screen display looks, etc. */

import { Pipe, PipeTransform } from '@angular/core';
import { XdaStringsService } from '../services/xda-strings.service';

@Pipe({
  name: 'xdaTranslate',
  pure: false,
  standalone: false,
})
export class XdaTranslate implements PipeTransform {
  formatValues: string[];

  constructor(private xdaStringsService: XdaStringsService) {
    this.formatValues = [];
  }

  transform(value: string, formatValues: string | string[] = ''): string {
    let translatedString = this.xdaStringsService.strings[value] || value;

    if (translatedString.includes('{0}')) {
      if (!Array.isArray(formatValues)) {
        this.formatValues.push(formatValues);
      } else {
        this.formatValues = formatValues;
      }

      const matches = translatedString.match(/\{(\d)\}/g);
      // the length of format values doesn't have to match the length of the placeholder.
      if (matches && matches.length > 0) {
        for (let i = 0; i < matches.length; i++) {
          let formatValue = '';
          if (i < this.formatValues.length && this.formatValues[i]) {
            formatValue =
              this.xdaStringsService.strings[this.formatValues[i]] ||
              this.formatValues[i];
          }

          translatedString = translatedString.replace(matches[i], formatValue);
        }
      }
    }
    return translatedString;
  }
}
